export default __webpack_public_path__ + "static/char-s-38-ko-fed7127dc1e1d420fa96349395714c32.webp";